import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Data } from '@angular/router';


@Component({
  selector: 'app-mro-expert-setting',
  templateUrl: './mro-expert-setting.component.html',
  styleUrls: ['./mro-expert-setting.component.scss']
})
export class MroExpertSettingComponent implements OnInit {

  conditionForm: FormGroup;
  editValidateForm: FormGroup;
  addValidateForm: FormGroup;
  statList: any[] = ['Y', 'N'];
  loading: boolean = false;
  userOptionList = [];
  editOptionList = [];
  addOptionList = [];
  listOfCurrentPageData: readonly Data[] = [];
  listenForm = new EventEmitter();
  searchTimeout: any;
  listOfData = [];
  detailData: any;
  checked = false;
  indeterminate = false;
  isEditModalVisible = false;
  isAddModalVisible = false;
  setOfCheckedId = new Set<number>();
  pageIndex: number = 1;
  pageSize: number = 20;
  total: number = 0;
  private readonly maxUserOptions = 10;

  constructor(
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.conditionForm = this.fb.group(
      {
        userId: '',
        roleName: '',
        useful: ''
      }
    );
    this.editValidateForm = this.fb.group(
      {
        roleChineseName: '',
        roleEnglishName: '',
        userId: '',
        userName: '',
        roleId: ''
      });
    this.addValidateForm = this.fb.group({
      roleChineseName: '',
      roleEnglishName: '',
      userId: '',
      roleId: ''
    });
    this.onSearch();
  }

  onCancel(): void {
    this.isEditModalVisible = false;
    this.addValidateForm.reset({
      roleChineseName1: { value: '', disabled: false },
      roleEnglishName1: { value: '', disabled: false },
      userId: '',
      roleId: ''
    });
  }

  onSure(event: any): void {
    const formValue = this.editValidateForm.getRawValue();
    const params = {
      data: {
        userId: this.getUserId(formValue.userId) || null,
        roleChineseName: formValue.roleChineseName,
        roleEnglishName: formValue.roleEnglishName,
        userName: this.getUserName(formValue.userId),
        roleId: formValue.roleId
      }
    };
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.UpdateMroExpertSetting.url}`;

    this.WebApiService.doGetpost(url, params).subscribe(res => {
      if (res && res.body.status === '200') {
        this.isEditModalVisible = false;
        this.NzMessageService.success(res.body.msg);
        this.onSearch();
      }
      else {
        this.NzMessageService.error(res.body.msg);
        this.onSearch();
      }
    });

  }

  onAddSure(event: any): void {
    const formValue = this.addValidateForm.getRawValue();
    const params = {
      data: {
        userId: this.getUserId(formValue.userId) || null,
        roleChineseName: formValue.roleChineseName,
        roleEnglishName: formValue.roleEnglishName,
        userName: this.getUserName(formValue.userId),
        roleId: formValue.roleId
      }
    };
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.AddMroExpertSetting.url}`;

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        this.NzMessageService.success('Add Success');
        this.isAddModalVisible = false;
        this.onSearch();
      },
      (error) => {
        this.NzMessageService.error('Add Fail');
        this.isAddModalVisible = false;
        this.onSearch();
      }
    );
  };

  onAddCancel(): void { this.isAddModalVisible = false; };

  onSearch(): void {
    this.loading = true;
    const params = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      data: {
        roleName: this.conditionForm.value.roleName,
        userId: this.conditionForm.value.userId,
        useful: this.conditionForm.value.useful,
      }
    };

    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetMroExpertSetting.url}`;

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        this.listOfData = res.data
        this.total = res.total
        this.loading = false
      },
      (error) => {
        this.loading = false
      }
    );
  };

  onEdit(data: any): void {
    this.isEditModalVisible = true;
    this.detailData = data;
    // 暂时启用控件
    this.editValidateForm.get('roleChineseName')?.enable({ emitEvent: false });
    this.editValidateForm.get('roleEnglishName')?.enable({ emitEvent: false });
    this.editValidateForm.patchValue({
      roleChineseName: data.roleChineseName || '',
      roleEnglishName: data.roleEnglishName || '',
      userId: data.userId || '',
      userName: data.userName || '',
      roleId: data.roleId || ''
    });
    // 重新禁用控件
    this.editValidateForm.get('roleChineseName')?.disable({ emitEvent: false });
    this.editValidateForm.get('roleEnglishName')?.disable({ emitEvent: false });
    this.userSearch(data.userId, 'edit')
  }

  onDelete(data: any): void {
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.DeleteMroExpertSetting.url}`;
    const params = {
      data: data
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        this.NzMessageService.success('Delete Success');
        this.onSearch();
      },
      (error) => {
        this.NzMessageService.error('Delete Fail');
        this.onSearch();
      }
    );
  }

  userSearch(event: string, type: string) {
    this.loading = true;
    event = event.trim().toUpperCase();

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (event.length > 3) {
      this.searchTimeout = setTimeout(() => {
        const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.QueryUser.url}` + event;

        this.WebApiService.doGet(url).toPromise().then(
          (res) => {
            const userOptions = this.normalizeUserOptions(res.data);
            if (type === 'edit') {
              this.editOptionList = userOptions;
              const user = this.editOptionList.find((item: any) => this.getUserId(item) === event);
              this.editValidateForm.controls['userId'].setValue(user);
            }
            else if (type === 'add') {
              this.addOptionList = userOptions;
            }

            this.loading = false;
          },
          (error) => {
            this.NzMessageService.error(error.msg);
            this.loading = false;
          }
        );
      }, 200);
    } else {
      this.loading = false;
    }
  }

  AddMROExpertItem(): void {
    this.isAddModalVisible = true;
  };

  userSearch1(event: string) {
    this.loading = true;
    event = event.trim().toUpperCase();

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (event.length > 3) {
      this.searchTimeout = setTimeout(() => {
        const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.QueryUser.url}` + event;

        this.WebApiService.doGet(url).toPromise().then(
          (res) => {
            this.userOptionList = this.normalizeUserOptions(res.data);

            this.loading = false;
          },
          (error) => {
            this.NzMessageService.error(error.msg);
            this.loading = false;
          }
        );
      }, 200);
    } else {
      this.loading = false;
    }
  }

  private normalizeUserOptions(users: any[] = []): any[] {
    return (users || []).slice(0, this.maxUserOptions).map(user => {
      const userId = user?.userId || user?.subjectId || '';
      const userName = user?.englishName || user?.chineseName || user?.username || '';

      return {
        ...user,
        userId,
        subjectId: user?.subjectId || userId,
        username: user?.username || userName,
        displayLabel: `${userId}/${userName}`
      };
    });
  }

  private getUserId(user: any): string {
    if (!user) {
      return '';
    }

    if (typeof user === 'string') {
      return user;
    }

    return user.userId || user.subjectId || '';
  }

  private getUserName(user: any): string {
    if (!user || typeof user === 'string') {
      return '';
    }

    return user.englishName || user.chineseName || user.username || '';
  }

  sortChange(sort: { key: string, value: string }): void {
    this.sortData(sort);
    // 可以在这里添加额外的逻辑，比如更新视图等
  }

  sortData(sort: { key: string, value: string }): void {
    this.listOfData.sort((a, b) => {
      const modifier = sort.value === 'ascend' ? 1 : -1;
      if (a[sort.key] < b[sort.key]) {
        return -1 * modifier;
      }
      if (a[sort.key] > b[sort.key]) {
        return 1 * modifier;
      }
      return 0;
    });
  }

  onCurrentPageDataChange(listOfCurrentPageData: readonly Data[]): void {
    this.listOfCurrentPageData = listOfCurrentPageData;

    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(({ id }) => this.setOfCheckedId.has(id));
    this.indeterminate = this.listOfCurrentPageData.some(({ id }) => this.setOfCheckedId.has(id)) && !this.checked;

  }
  // valuehandleChange(): void {
  //   // var sitecode = this.validateForm.controls['Site'].value;
  //   let value = {};
  //   Object.keys(this.conditionForm.controls).forEach((key) => {

  //     if (key === 'Site') {
  //       value[key] = this.conditionForm.controls[key].value
  //       // this.VendorList= this.list.filter(s => s.site == sitecode);
  //     }
  //     else {
  //       value[key] = this.conditionForm.controls[key].value;
  //     }
  //   });
  //   this.listenForm.emit(value);
  //   console.log(    this.conditionForm);

  // }

}
